import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Box, Button, Stack, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { AccountCircle } from '@mui/icons-material';
import PremiumCard from 'components/shared/surfaces/PremiumCard';
import { premiumButtonSx } from 'common/theme/button/premiumButtonSx';
import { ReactComponent as Logo } from 'images/logo.svg';
import routes from 'common/routes';

function IncompleteProfileBlock() {
  const { t } = useTranslation(['common']);
  const theme = useTheme();

  // Watermark del logo OTRIX difuminado a la mitad (mismo efecto que el hero/cards).
  // En oscuro invertido a blanco; en claro a color, vía `brand.logoFilter`.
  const logoWatermarkStyles = {
    position: 'absolute',
    right: 0,
    top: 0,
    height: '100%',
    opacity: 0.04,
    filter: theme.palette.brand.logoFilter,
    transform: 'translateX(34%)',
    pointerEvents: 'none'
  };

  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '50vh' }}>
      <PremiumCard
        sx={{ maxWidth: 460, width: '100%' }}
        innerSx={{ position: 'relative', overflow: 'hidden' }}
        padding={{ xs: 4, md: 5 }}>
        <Logo aria-hidden style={logoWatermarkStyles} />
        <Stack spacing={3} alignItems="center" sx={{ position: 'relative', textAlign: 'center' }}>
          <Box
            sx={{
              width: 72,
              height: 72,
              borderRadius: '50%',
              flex: 'none',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              backgroundColor: 'gold.soft',
              border: '1px solid',
              borderColor: 'rgba(249, 189, 78, 0.25)'
            }}>
            <AccountCircle sx={{ fontSize: 40, color: 'gold.main' }} />
          </Box>
          <Typography variant="body1" sx={{ color: 'text.primary', fontWeight: 500, maxWidth: 320 }}>
            {t('profile.incompleteBlock', { ns: 'common' })}
          </Typography>
          <Button
            component={RouterLink}
            to={routes.clientProfile.path}
            fullWidth
            sx={{ ...premiumButtonSx, maxWidth: 280 }}>
            {t('profile.completeProfile', { ns: 'common' })}
          </Button>
        </Stack>
      </PremiumCard>
    </Box>
  );
}

export default IncompleteProfileBlock;
